import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import i18n from '../constants/initLng';
import { getImageTypeByDirectory, readableFileSize, detectMimeFromMagicBytes } from '../utils/commonUtils';
import * as UploadActions from '../actions/uploadAction';
import * as UploadService from '../services/uploadService';
import { UPLOAD } from '../constants/Define';
import { notification } from 'antd';

const typeVideo = ["video/mp4", "video/mov", "video/wmv", "video/flv", "video/3g2", "video/3gp"];
const typeImg = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/gif'];
const typeExcel = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
function* uploadFile() {
    yield takeEvery(Types.UPLOAD_FILE_ACTION, Func.sagaWrapper(function* (action) {
        const file = action.filters.file;
        const typeFile = yield call(detectMimeFromMagicBytes, file);
        const ImageUrlSlug = action.filters.ImageUrlSlug;
        if (!typeFile || (!typeVideo.includes(typeFile) && !typeImg.includes(typeFile) && !typeExcel.includes(typeFile))) {
            yield put(UploadActions.uploadReset());
            notification.error({
                message: i18n.t('validation.statusCode.code.FILE_TYPE_NOT_ACCEPTED'),
            })
            return;
        }
        if (typeVideo.includes(typeFile) && file.size > UPLOAD.MAX_VIDEO_UPLOAD_SIZE){
            yield put(UploadActions.uploadReset());
            notification.error({
                message: i18n.t('validation.statusCode.code.FILE_LENGTH_OVER_LIMIT'),
                description: `${i18n.t('notification.maxFileSize')}: ${readableFileSize(UPLOAD.MAX_VIDEO_UPLOAD_SIZE, 0)}`
            })
            return;
        }
        if ((typeImg.includes(typeFile) || typeExcel.includes(typeFile)) && file.size > UPLOAD.MAX_FILE_SIZE) {
            yield put(UploadActions.uploadReset());
            notification.error({
                message: i18n.t('validation.statusCode.code.FILE_LENGTH_OVER_LIMIT'),
                description: `${i18n.t('notification.maxFileSize')}: ${readableFileSize(UPLOAD.MAX_FILE_SIZE, 0)}`
            })
            return;
        } else {
            const formData = new FormData();
            const fieldName = action.filters.fieldName;
            const type = getImageTypeByDirectory(action.filters.directory);
            formData.append('file', file);
            formData.append('directory', action.filters.directory);
            if(ImageUrlSlug){
                formData.append('ImageUrlSlug', ImageUrlSlug);
            }
            const result = yield call(UploadService.uploadFile, formData);
            result.field = action.filters.field;
            result.isFile = action.filters.isFile;
            action.filters.onUploaded && action.filters.onUploaded();
            yield put(UploadActions.uploadSuccess({ data: result, type }, fieldName));
            Func.sagaSuccessMessage(action, i18n.t('notification.uploadSuccess'), file.name);
            yield put({type: Types.UPLOAD_FILE_RESET});
        }
    }, errorHandleUpload(Types.UPLOAD_FILE_RESET)))
}

function errorHandleUpload(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'banner');
}

export function* uploadSaga() {
    yield all([
        fork(uploadFile),
    ])
}
